import CircleCollection from "./circleCollection";

export default class DrusenCircles3 extends CircleCollection {
  constructor(position, options) {
    let circleDefs = [{ radius: 1273, text: "½ DA" }];
    super(position, circleDefs, options);
  }
}
